import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import DataDeletionRequest from "./pages/DataDeletionRequest";
import Blogs from "./pages/Blogs";
import BlogPost from "./pages/BlogPost";
import BlogDashboard from "./pages/BlogDashboard";
import AdminLogin from "./pages/AdminLogin";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToHash from "./components/ScrollToHash";
import ProtectedAdminRoute from "./components/ProtectedAdminRoute";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToHash />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/:slug" element={<BlogPost />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin/blogs"
            element={
              <ProtectedAdminRoute>
                <BlogDashboard />
              </ProtectedAdminRoute>
            }
          />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/data-deletion-request" element={<DataDeletionRequest />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
